import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSettings } from "../hooks/useAppSettings.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../store/index.ts";
import AdminDashboard from "./dashboard/AdminDashboard.tsx";
import { legacyHomeTarget } from "../auth/legacyHome.ts";
import { can } from "../auth/can.ts";

const Dashboard = () => {
  useAppSettings();
  const { user } = useSelector((state: RootState) => state.auth);
  const target = legacyHomeTarget(user.rol);

  if (target.kind === "dashboard") {
    return <AdminDashboard />;
  }

  if (target.kind === "navigate") {
    return <Navigate to={target.to} />;
  }

  if (can("applications.view", user)) {
    return <AdminDashboard />;
  }

  const fallback = (
    [
      ["attendance.check", "reloj-checador"],
      ["vacancies.view", "/vacantes"],
      ["proceedings.view", "solicitudes"],
      ["reports.birthdates", "birthdates"],
      ["branches.view", "sucursales"],
    ] as const
  ).find(([permission]) => can(permission, user));

  if (fallback) {
    return <Navigate to={fallback[1]} />;
  }

  return (
    <div className="p-4">
      Tu usuario no tiene módulos asignados.
    </div>
  );
};

export default Dashboard;
